// extracted by mini-css-extract-plugin
export default {"productGrid":"d2-z","centerLink":"e2-z","productSection":"f2-z","item":"g2-z","ctaButton":"h2-z"};